import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiIntellijidea,
  SiPostman,
  SiUbuntu,
  SiJira
} from "react-icons/si";
import { FaDocker } from "react-icons/fa";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons" title="Ubuntu">
        <SiUbuntu />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title="Docker">
        <FaDocker />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title="IntelliJ IDEA">
        <SiIntellijidea />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title="Postman">
        <SiPostman />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title="Jira">
        <SiJira />
      </Col>
    </Row>
  );
}

export default Toolstack;
